<link rel="ractive" href="../components/new-infographic-banner.html" name="c-new-infographic-banner" />
<link rel="ractive" href="./stats-table.html" name="c-stats-table" />
<link rel="ractive" href="./slider.html" name="c-slider" />
<link rel="ractive" href="./slide.html" name="c-slide" />
<link rel="ractive" href="../components/proxy-data-card.html" name="c-proxy-data-card" />

<!-- Commenting this out while we switch to another API -->
<!-- <link rel="ractive" href="./rum.html" name="c-rum"> -->

<div class="c-landing-bottom">
	<div class="container-fluid container-mw">
		<div class="row">
			<div class="col-xs-12 col-lg-10 col-lg-push-1">
				<section class="features wrapper">
					<span>Multi-CDN Global Network</span>
					<h2>Built for production</h2>

					<div class="features_features-list">
						<a href="/network/infographic">
							<img width="64"
								height="64"
								src="{{@shared.assetsHost}}/img/landing/new/built-for-prod/1.svg" />
							<h6>Four CDN<br /> & three DNS providers</h6>
						</a>

						<a href="/network#map">
							<img width="64"
								height="64"
								src="{{@shared.assetsHost}}/img/landing/new/built-for-prod/2.svg" />
							<h6>More than 540 points<br /> of presence</h6>
						</a>

						<a href="/network#china">
							<img width="64"
								height="64"
								src="{{@shared.assetsHost}}/img/landing/new/built-for-prod/3.svg" />

							<h6>Low latency "Near China"<br /> network</h6>
						</a>

						<a href="/documentation#id-multi-cdn">
							<img width="64"
								height="64"
								src="{{@shared.assetsHost}}/img/landing/new/built-for-prod/4.svg" />
							<h6>Smart load-balancing<br /> and routing</h6>
						</a>

						<a href="/network#failover">
							<img width="64"
								height="64"
								src="{{@shared.assetsHost}}/img/landing/new/built-for-prod/5.svg" />
							<h6>Multi-layer cache<br /> and failover</h6>
						</a>

						<a href="/terms">
							<img width="64"
								height="64"
								src="{{@shared.assetsHost}}/img/landing/new/built-for-prod/6.svg" />
							<h6>Formal ToS<br /> and Privacy Policy</h6>
						</a>
					</div>
				</section>

				<section class="network-data">
					<svg
						width="908"
						height="428"
						viewBox="0 0 908 428"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<g transform="translate(64, 144)">
							<circle r="2" />
							<circle r="2" />
						</g>
						<g transform="translate(136, 120)">
							<circle r="2" />
							<circle r="2" />
						</g>
						<g transform="translate(176, 152)">
							<circle r="2" />
							<circle r="2" />
						</g>
						<g transform="translate(224, 376)">
							<circle r="2" />
							<circle r="2" />
						</g>
						<g transform="translate(384, 128)">
							<circle r="2" />
							<circle r="2" />
						</g>
						<g transform="translate(400, 136)">
							<circle r="2" />
							<circle r="2" />
						</g>
						<g transform="translate(416, 96)">
							<circle r="2" />
							<circle r="2" />
						</g>
						<g transform="translate(440, 104)">
							<circle r="2" />
							<circle r="2" />
						</g>

						<g transform="translate(792, 224)">
							<circle r="2" />
							<circle r="2" />
						</g>

						<g transform="translate(848, 352)">
							<circle r="2" />
							<circle r="2" />
						</g>
					</svg>

					<div class="wrapper-lg">
						<div class="network-data_stats">
							<div class="network-data_stats_item">
								<img width="80" height="80" src="{{@shared.assetsHost}}/img/landing/new/map-icons/1.svg" />
								{{#if netStatsToAnimate}}
									<div class="network-data_stats_item_green">
										<span>1 mil+</span>
										<span>active oss projects served</span>
									</div>
								{{/if}}
							</div>

							<div class="network-data_stats_item">
								<img width="80" height="80" src="{{@shared.assetsHost}}/img/landing/new/map-icons/2.svg" />
								{{#if netStatsToAnimate}}
									<div class="network-data_stats_item_green">
										<span>99.46%</span>
										<span>cache hit ratio</span>
									</div>
								{{/if}}
							</div>

							<div class="network-data_stats_item">
								<img width="80" height="80" src="{{@shared.assetsHost}}/img/landing/new/map-icons/3.svg" />
								{{#if netStatsToAnimate}}
									<div class="network-data_stats_item_regular">
										<span>{{ _.formatNumber(netStatsToAnimate.requestsPerSecond) }}</span>
										<span>requests per second</span>
									</div>
								{{/if}}
							</div>

							<div class="network-data_stats_item">
								<img width="80" height="80" src="{{@shared.assetsHost}}/img/landing/new/map-icons/4.svg" />
								{{#if netStatsToAnimate}}
									<div class="network-data_stats_item_regular">
										<span>{{ _.formatNumber(netStatsToAnimate.bandwidth) }} Mbps</span>
										<span>bandwidth</span>
									</div>
								{{/if}}
							</div>
						</div>

						<div class="btn-link-to">
							<a class="btn-arrow" href="/network#map">
								<span>View our network map</span>
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/arrow-right.svg" />
							</a>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>

	<section class="dev-friendly">
		<div class="wrapper-lg">
			<div class="wrapper">
				<h4>Developer Friendly</h4>
				<p>
					All files from <span>npm</span> and
					<span>GitHub</span> available with zero setup
				</p>

				<div class="dev-friendly_features-list">
					<a href="/statistics">
						<img width="64"
							height="64"
							src="{{@shared.assetsHost}}/img/landing/new/dev-friendly/1.svg" />
						<h6>Usage statistics</h6>
					</a>

					<a href="/documentation#id-combine-multiple-files">
						<img width="64"
							height="64"
							src="{{@shared.assetsHost}}/img/landing/new/dev-friendly/2.svg" />
						<h6>Combine multiple<br />files on-demand</h6>
					</a>

					<a href="/documentation#id-npm">
						<img width="64"
							height="64"
							src="{{@shared.assetsHost}}/img/landing/new/dev-friendly/3.svg" />
						<h6>Minify files on-demand</h6>
					</a>

					<a href="/documentation#id-npm">
						<img width="64"
							height="64"
							src="{{@shared.assetsHost}}/img/landing/new/dev-friendly/4.svg" />
						<h6>Source map support</h6>
					</a>

					<a href="/documentation#id-npm">
						<img width="64"
							height="64"
							src="{{@shared.assetsHost}}/img/landing/new/dev-friendly/5.svg" />
						<h6>Version aliasing</h6>
					</a>

					<a target="_blank" rel="noopener noreferrer" href="https://github.com/jsdelivr?q=plugin">
						<img width="64"
							height="64"
							src="{{@shared.assetsHost}}/img/landing/new/dev-friendly/6.svg" />
						<h6>Multiple<br />IDE Integrations</h6>
					</a>
				</div>
			</div>
		</div>

		<div class="dev-friendly_gradient"></div>
		<div class="dev-friendly_image"></div>
	</section>

	<div class="container-fluid container-mw">
		<div class="row">
			<div class="col-xs-12">
				<section class="api wrapper-lg">
					<div class="api_content">
						<h3>
							A free API for all your <br />
							NPM and ESM needs
						</h3>
						<p>
							The jsDelivr API allows you to get details about
							NPM packages, such as their versions, tags, and files.
							By analyzing package metadata and its real usage,
							it can automatically suggest the correct entry point
							for each file type.
						</p>
						<p>
							Additionally the API provides detailed download statistics
							for each project, version, and file, as well as network-wide
							usage statistics.
						</p>

						<div class="btn-link-to">
							<a class="btn-arrow router-ignore" href="/docs/data.jsdelivr.com">
								<span>Read the API documentation</span>
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/arrow-right.svg" />
							</a>
						</div>
					</div>

					<div class="api_code code">
						<div class="code-head">
							<span></span>
							<span></span>
							<span></span>
						</div>

						<div class="code-tabs">
							<a on-click="@this.set('activeTab', 'entrypoints')" class="{{#if activeTab === 'entrypoints'}}active{{/if}}">
								Get project entry points
							</a>

							<a on-click="@this.set('activeTab', 'versions')" class="{{#if activeTab === 'versions'}}active{{/if}}">
								List project versions
							</a>

							<a on-click="@this.set('activeTab', 'files')" class="{{#if activeTab === 'files'}}active{{/if}}">
								List package files
							</a>

							<div class="code-tabs-line" style="left: {{activeTabLineData[0]}}px; width: {{activeTabLineData[1]}}px;"></div>

							<div class="dropdown">
								<button class="dropdown-toggle"
									type="button"
									id="cdn-dropdown"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="true">
									<img width="20"
										height="20"
										src="{{@shared.assetsHost}}/img/icons/chevron-down.svg"
										loading="lazy" />
								</button>
								<ul class="dropdown-menu dropdown-menu-right" aria-labelledby="cdn-dropdown">
									{{#each ~/codeList}}
										<li>
											<a on-click="@this.set('activeTab', this)">{{this}}</a>
										</li>
									{{/each}}
								</ul>
							</div>
						</div>

						<div class="code-slider">
							<c-slider active="{{activeSlide}}" direction="horizontal" distance="500" duration="0">
								<c-slide>
									<div class="code-slide entrypoints">
										<div class="code-lines-counter"></div>

										<div class="code-wrapper">
											<div class="code-link">
												<span>https://data.jsdelivr.com/v1/packages/npm/bootstrap@5.1.0/entrypoints</span>
											</div>
											<div>&nbsp;</div>
											<div>// =></div>
											<div>{</div>
											<div>&nbsp;&nbsp;"
												<span class="code-key">entrypoints</span>
												": {
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">js</span>
												": {
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">file</span>
												": "
												<span class="code-string">/</span>
												<span class="code-string">dist</span>
												<span class="code-string">/</span>
												<span class="code-string">js</span>
												<span class="code-string">/</span>
												<span class="code-string">bootstrap</span>
												<span class="code-string">.min</span>
												<span class="code-string">.js</span>
												",
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">guessed</span>
												":
												<span class="code-boolean">&nbsp;false</span>
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;},
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">css</span>
												": {
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">file</span>
												": "
												<span class="code-string">/</span>
												<span class="code-string">dist</span>
												<span class="code-string">/</span>
												<span class="code-string">css</span>
												<span class="code-string">/</span>
												<span class="code-string">bootstrap</span>
												<span class="code-string">.min</span>
												<span class="code-string">.css</span>
												",
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">guessed</span>
												":
												<span class="code-boolean">&nbsp;false</span>
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;}
											</div>
											<div>&nbsp;&nbsp;}</div>
											<div>}</div>
										</div>
									</div>
								</c-slide>

								<c-slide>
									<div class="code-slide versions">
										<div class="code-lines-counter"></div>

										<div class="code-wrapper">
											<div class="code-link">
												<span>https://data.jsdelivr.com/v1/packages/npm/bootstrap</span>
											</div>
											<div>&nbsp;</div>
											<div>// =></div>
											<div>{</div>
											<div>
												&nbsp;&nbsp;"
												<span class="code-key">tags</span>
												": {
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">latest</span>
												": "
												<span class="code-string">5.1.0</span>
												"
											</div>
											<div>&nbsp;&nbsp;},
											</div>
											<div>&nbsp;&nbsp;"
												<span class="code-key">versions</span>
												": [
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;{
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">version</span>
												": "
												<span class="code-string">5.1.0</span>
												",
											</div>
											<div>
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">links</span>
												": { ... }
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;},
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;...
											</div>
											<div>&nbsp;&nbsp;]
											</div>
											<div>}</div>
										</div>
									</div>
								</c-slide>

								<c-slide>
									<div class="code-slide files">
										<div class="code-lines-counter"></div>

										<div class="code-wrapper">
											<div class="code-link">
												<span>https://data.jsdelivr.com/v1/packages/npm/bootstrap@5.1.0</span>
											</div>
											<div>&nbsp;</div>
											<div>// =></div>
											<div>{</div>
											<div>&nbsp;&nbsp;"
												<span class="code-key">default</span>
												": "
												<span class="code-string">/dist/js/bootstrap.min.js</span>
												",
											</div>
											<div>&nbsp;&nbsp;"
												<span class="code-key">files</span>
												": [
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;{
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">type</span>
												": "
												<span class="code-string">file</span>
												",
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">name</span>
												": "
												<span class="code-string">package.json</span>
												",
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">hash</span>
												": "
												<span class="code-string">j19bdlJ6sukErRbeEIVWdlup1uM8tAg8c0INKUgkvHI=</span>
												",
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">size</span>
												":
												<span class="code-number">&nbsp;9352</span>
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;},
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;{
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">type</span>
												": "
												<span class="code-string">file</span>
												",
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">name</span>
												": "
												<span class="code-string">README.md</span>
												",
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">hash</span>
												": "
												<span class="code-string">0VD+BFt1wT4LdvxuZYxl2657grnDUvEoRso1T0QcoIo=</span>
												",
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
												<span class="code-key">size</span>
												":
												<span class="code-number">&nbsp;13566</span>
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;},
											</div>
											<div>&nbsp;&nbsp;&nbsp;&nbsp;...
											</div>
											<div>&nbsp;&nbsp;]
											</div>
											<div>}</div>
										</div>
									</div>
								</c-slide>
							</c-slider>
						</div>
					</div>
				</section>

				<c-new-infographic-banner></c-new-infographic-banner>

				<section class="js-modules wrapper-lg">
					<div class="js-modules_content">
						<h3>A New-Age CDN for<br />JavaScript modules</h3>
						<p>
							Load modern JavaScript packages built for you on-demand.
							<br />Works in modern web browsers, node.js, and deno.
						</p>

						<div class="js-modules_content_checklist">
							<div>
								<img width="24"
									height="24"
									src="{{@shared.assetsHost}}/img/icons/check-circle.svg" />
								Global Multi-CDN
							</div>

							<div>
								<img width="24"
									height="24"
									src="{{@shared.assetsHost}}/img/icons/check-circle.svg" />
								HTTP/3, minification, brotli compression, fine-tuned
								HTTP caching, dependency preloading
							</div>

							<div>
								<img width="24"
									height="24"
									src="{{@shared.assetsHost}}/img/icons/check-circle.svg" />
								Permanent storage shared by all edge servers
							</div>
						</div>


						<div class="btn-link-to">
							<a class="btn-arrow" href="/esm">
								<span>Learn more about ESM</span>
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/arrow-right.svg" />
							</a>
						</div>
					</div>

					<div class="js-modules_code code">
						<div class="code-head">
							<span></span>
							<span></span>
							<span></span>
						</div>

						<div class="js-modules_code_wrapper">
							<div class="js-modules_code_wrapper_counters"></div>

							<pre class="code-colors">
								<span><span class="code-colors_reserved">import</span>&nbsp;{&nbsp;<span class="code-colors_var">Fireworks</span>&nbsp;}&nbsp;<span class="code-colors_reserved">from</span>&nbsp;'<span class="code-colors_string">https://esm.run/fireworks-js</span>';</span>
								<span></span>
								<span><span class="code-colors_reserved">let</span>&nbsp;<span class="code-colors_var">container</span>&nbsp;=&nbsp;<span class="code-colors_obj">document</span>.<span class="code-colors_method">querySelector</span>('<span class="code-colors_string">.container</span>');</span>
								<span></span>
								<span><span class="code-colors_reserved">let</span>&nbsp;<span class="code-colors_var">options</span>&nbsp;=&nbsp;{
									&nbsp;&nbsp;<span class="code-colors_key">gravity</span>:&nbsp;<span class="code-colors_number">1.4</span>,
									&nbsp;&nbsp;<span class="code-colors_key">opacity</span>:&nbsp;<span class="code-colors_number">0.4</span>,
									&nbsp;&nbsp;<span class="code-colors_key">autoresize</span>:&nbsp;<span class="code-colors_boolean">true</span>,
									&nbsp;&nbsp;<span class="code-colors_key">acceleration</span>:&nbsp;<span class="code-colors_number">1.00</span>,
									};
								</span>
								<span><span class="code-colors_reserved">let</span>&nbsp;<span class="code-colors_var">fireworks</span>&nbsp;=&nbsp;<span class="code-colors_reserved">new</span>&nbsp;<span class="code-colors_obj">Fireworks</span>(<span class="code-colors_var">container</span>, <span class="code-colors_var">options</span>);</span>
								<span></span>
								<span><span class="code-colors_obj">fireworks</span>.<span class="code-colors_method">start</span>();</span>
								<span></span>
								</pre>
						</div>

						<div class="code-footer">
							<span>
								{{#if esmDemoLoadTime !== null}}
									{{#if esmDemoLoadTime}}
										{{esmDemoLoadTime}} ms, loaded from the CDN
									{{else}}
										{{esmDemoLoadTime}} ms, still cached
									{{/if}}
								{{/if}}
							</span>

							<button on-click="@this.runEsmDemo(@event)" class="btn-primary">Run</button>
						</div>
					</div>
				</section>

				<section class="top-packages wrapper-lg">
					<div class="top-packages_analytics-graph">
						<svg width="1216" height="520" viewBox="0 0 1216 520" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g transform="translate(5 0)">
								<rect width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="45" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="90" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="135" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="180" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="225" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="270" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="315" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="360" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="405" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="450" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="495" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="540" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="585" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="630" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="675" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="720" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="765" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="810" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="855" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="900" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="945" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="990" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="1035" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="1080" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="1125" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="1170" width="1" height="520" fill="url(#paint_line_linear0)"/>
								<rect x="1215" width="1" height="520" fill="url(#paint_line_linear0)"/>
							</g>
							<g width="592" height="253" transform="translate(0 260)">
								<path d="M7 246L51 206L96 246L141 206L186 166L232 206L277 166L322 126L366 86L411 46L456 86L500 46L545 6L591 46" stroke="url(#paint_line_linear1)" stroke-width="2" stroke-linecap="round"/>
								<circle cx="6.5" cy="246.5" r="4.5" fill="white"/>
								<circle cx="6.5" cy="246.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="51.5" cy="206.5" r="4.5" fill="white"/>
								<circle cx="51.5" cy="206.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="96.5" cy="246.5" r="4.5" fill="white"/>
								<circle cx="96.5" cy="246.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="141.5" cy="206.5" r="4.5" fill="white"/>
								<circle cx="141.5" cy="206.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="186.5" cy="166.5" r="4.5" fill="white"/>
								<circle cx="186.5" cy="166.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="231.5" cy="206.5" r="4.5" fill="white"/>
								<circle cx="231.5" cy="206.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="276.5" cy="166.5" r="4.5" fill="white"/>
								<circle cx="276.5" cy="166.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="321.5" cy="126.5" r="4.5" fill="white"/>
								<circle cx="321.5" cy="126.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="366.5" cy="86.5" r="4.5" fill="white"/>
								<circle cx="366.5" cy="86.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="411.5" cy="46.5" r="4.5" fill="white"/>
								<circle cx="411.5" cy="46.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="456.5" cy="86.5" r="4.5" fill="white"/>
								<circle cx="456.5" cy="86.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="501.5" cy="46.5" r="4.5" fill="white"/>
								<circle cx="501.5" cy="46.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
								<circle cx="545.5" cy="6.5" r="4.5" fill="white"/>
								<circle cx="545.5" cy="6.5" r="5.5" stroke="#F65128" stroke-opacity="0.24" stroke-width="2"/>
							</g>
							<defs>
								<linearGradient id="paint_line_linear0" x1="0.5" y1="0" x2="0.5" y2="520" gradientUnits="userSpaceOnUse">
									<stop stop-color="#EDF0F2" stop-opacity="0"/>
									<stop offset="0.458333" stop-color="#EDF0F2"/>
									<stop offset="1" stop-color="#EDF0F2" stop-opacity="0"/>
								</linearGradient>
								<linearGradient id="paint_line_linear1" x1="299" y1="6" x2="299" y2="246" gradientUnits="userSpaceOnUse">
									<stop stop-color="#F65128"/>
									<stop offset="1" stop-color="#F65128" stop-opacity="0.08"/>
								</linearGradient>
							</defs>
						</svg>
					</div>

					<div class="top-packages_content">
						<h3>Analytics and Stats</h3>

						<p>
							Use our stats to better understand how your projects are being used,
							which versions are popular, and which files are being downloaded the most.
						</p>

						<div class="btn-link-to">
							<a class="btn-arrow" href="/statistics">
								<span>See more stats</span>
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/arrow-right.svg" />
							</a>
						</div>
					</div>

					<div class="top-packages_packages-list code">
						<div class="code-head">
							<span></span>
							<span></span>
							<span></span>
							<p class="title">Top 10 npm packages past 30 days</p>
						</div>

						<c-stats-table rowIndexes="true" data="{{topPackages.slice(0, 10)}}">
							{{#partial column1}}
								<a href="/package/{{type}}/{{name}}">
									<span class="prefix">{{type}}/</span>
									{{name}}
								</a>
							{{/partial}}
						</c-stats-table>
					</div>

					<div class="btn-link-to bottom">
						<a class="btn-arrow" href="/statistics">
							<span>See more stats</span>
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/arrow-right.svg" />
						</a>
					</div>
				</section>
			</div>
		</div>
	</div>

	<section class="endpoints wrapper-lg">
		<div class="endpoints_content">
			<h5>Custom CDN Endpoints</h5>
			<span>
				jsDelivr is happy to support unique OSS use-cases that require a fast CDN
			</span>

			<div class="btn-link-to">
				<a class="btn-arrow" href="/oss-cdn">
					<span>Explore all custom endpoints</span>
					<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/arrow-right.svg" />
				</a>
			</div>
		</div>

		<div class="endpoints_list">
			<div class="endpoints_list_wrapper">
				{{#each ossCdnProjects}}
					<c-proxy-data-card
							jsDelivrLink="{{jsDelivrLink}}"
							apiName="{{apiCdnName}}"
							period="month"
							bandwidthUnit="GB"
							imgSrc="{{imgSrc}}"
							imgWidth="{{imgWidth}}"
							imgHeight="{{imgHeight}}">
					</c-proxy-data-card>
				{{/each}}
			</div>
		</div>

		<div class="btn-link-to bottom">
			<a class="btn-arrow" href="/oss-cdn">
				<span>Explore all custom endpoints</span>
				<img width="20"
					height="20"
					src="{{@shared.assetsHost}}/img/icons/arrow-right.svg" />
			</a>
		</div>
	</section>


	<div class="container-fluid container-mw">
		<div class="row">
			<div class="divider"></div>
			<div class="col-xs-12">
				<section class="sponsors wrapper-lg">
						<div class="sponsors_content">
							<h5>jsDelivr is used by millions of websites globally</h5>

							<div class="btn-link-to">
								<a class="btn-arrow" href="/become-a-sponsor">
									<span>Become a sponsor</span>
									<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/arrow-right.svg" />
								</a>
							</div>
						</div>

						<div class="sponsors_sponsors-list {{ #if showMoreExLogo }} expanded {{ /if }}">
							<div class="sponsors_sponsors-list_list-wrapper">
								{{#each exWebLogo}}
									<img src="{{@shared.assetsHost}}/img/landing/new/external-websites/{{ .image }}" loading="lazy">
								{{/each}}
							</div>

							<div class="sponsors_sponsors-list_gradient"></div>

							<button class="btn-more btn-grey" on-click="@this.set('showMoreExLogo', !showMoreExLogo)">
								{{#if !showMoreExLogo}}
									Load more
								{{else}}
									Show less
								{{/if}}
							</button>
						</div>

						<div class="btn-link-to bottom">
							<a class="btn-arrow" href="/become-a-sponsor">
								<span>Become a sponsor</span>
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/arrow-right.svg" />
							</a>
						</div>
				</section>
			</div>
		</div>
	</div>

	<div class="fireworks"></div>
</div>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const codeTabs = [ 'entrypoints', 'versions', 'files' ];
	const FIREWORKS_ANIMATION_DURATION = 4000;
	const ossCdnProjects = require('../../assets/json/oss-cdn-projects.json');

	function createLineNums (heightSelector, lineHeightSelector, targetSelector) {
		let preOffsetHeight = document.querySelector(heightSelector).offsetHeight;
		let lineHeightEl = document.querySelector(lineHeightSelector);
		let lineHeight = Number(document.defaultView.getComputedStyle(lineHeightEl, null).getPropertyValue('line-height').replace('px', ''));
		let countedLines = Math.ceil(preOffsetHeight / lineHeight);
		let countersBlock = document.querySelector(targetSelector);

		for (let i = 1; i <= countedLines; i++) {
			let span = document.createElement('span');
			span.textContent = i;
			countersBlock.append(span);
		}
	}

	component.exports = {
		data () {
			return {
				_,
				activeTab: 'entrypoints',
				codeList: [ 'entrypoints', 'versions', 'files' ],
				// external website logos
				exWebLogo: [
					{ image: 'cnn.svg' },
					{ image: 'ikea.svg' },
					{ image: 'nvidia.svg' },
					{ image: 'nintendo.svg' },
					{ image: 'ubisoft.svg' },
					{ image: 'harvard.svg' },
					{ image: 'nba.svg' },
					{ image: 'coinmarketcap.svg' },
					{ image: 'mailonline.svg' },
					{ image: 'roblox.svg' },
					{ image: 'urban.svg' },
					{ image: 'rotten-tomatoes.svg' },
					{ image: 'olx.svg' },
					{ image: 'der-spiegel.svg' },
					{ image: 'upwork.svg' },
					{ image: 'govgr.svg' },
					{ image: 'tawk.to.png' },
					{ image: 'foot-locker.svg' },
					{ image: 'euro-vision.svg' },
				],
				showMoreExLogo: false,
				esmDemoLoadTime: null,
				esmDemoRunning: false,
				fireworks: null,
				netStatsAnimData: {
					reqMultiplier: 0,
					bandwMultiplier: 0,
				},
				ossCdnProjects,
			};
		},
		oninit () {
			this.findComponent('c-slider').set(
				'active',
				codeTabs.indexOf(this.get('activeTab')) !== -1
					? codeTabs.indexOf(this.get('activeTab'))
					: 0,
			);

			if (!Ractive.isServer) {
				this.observe('activeTab', (newValue) => {
					document.querySelector('.code-slider .c-slider').scrollTop = 0;

					this.findComponent('c-slider').show(codeTabs.indexOf(newValue) !== -1 ? codeTabs.indexOf(newValue) : 0);

					let activeTabLink = document.querySelectorAll('.code-tabs a')[this.get('activeSlide') || 0];
					this.set('activeTabLineData', [
						activeTabLink.offsetLeft,
						activeTabLink.clientWidth,
					]);

					setTimeout(() => {
						createLineNums(`.api_code .${newValue} .code-wrapper`, `.api_code .${newValue} .code-wrapper div`, `.api_code .${newValue} .code-lines-counter`);
					}, 100);
				}, { init: false });

				// Load top packages.
				http.fetchTopPackages().then((data) => {
					this.set('topPackages', data);
				});

				// Load network stats for the previous day
				http.fetchNetworkStats('month').then((data) => {
					this.set('baseRequestsPerSecond', data.hits.total / 30 / 24 / 60 / 60);
					this.set('baseBandwidth', data.bandwidth.total / 30 / 24 / 60 / 60 / 1e6);
				});

				setInterval(() => {
					let max = 102;
					let min = 97;
					let { reqMultiplier, bandwMultiplier } = this.get('netStatsAnimData');
					let newReqMultiplier = this.getNewMultiplier(min, max, reqMultiplier);
					let newBandwMultiplier = this.getNewMultiplier(min, max, bandwMultiplier);

					this.set('netStatsAnimData', { reqMultiplier: newReqMultiplier, bandwMultiplier: newBandwMultiplier });
				}, 1400);


				this.observe('netStatsAnimData', ({ reqMultiplier, bandwMultiplier }) => {
					let animationConfig = {
						easing: x => 1 - Math.sqrt(1 - Math.pow(x, 2)),
					};

					let netStatsToAnimate = {
						requestsPerSecond: reqMultiplier * this.get('baseRequestsPerSecond') || 0,
						bandwidth: bandwMultiplier * this.get('baseBandwidth') * 8 || 0,
					};

					this.animate('netStatsToAnimate', netStatsToAnimate, animationConfig);
				}, { init: false });
			}
		},
		oncomplete () {
			if (!Ractive.isServer) {
				createLineNums('.js-modules_code pre', '.js-modules_code pre span', '.js-modules_code_wrapper_counters');
				createLineNums('.api_code .entrypoints .code-wrapper', '.api_code .entrypoints .code-wrapper div', '.api_code .entrypoints .code-lines-counter');
			}
		},
		getRandomMultiplier (min, max) {
			return (Math.random() * (max - min + 1) + min) / 100;
		},
		getNewMultiplier (min, max, prevMultiplier) {
			let multiplier = this.getRandomMultiplier(min, max);

			if (multiplier === prevMultiplier) {
				return this.getNewMultiplier(min, max, multiplier);
			}

			return multiplier;
		},
		runEsmDemo (e) {
			performance.clearResourceTimings();
			let src = 'https://cdn.jsdelivr.net/npm/fireworks-js@2.10.1/+esm';

			import(src).then(({ Fireworks }) => {
				let entries = performance.getEntriesByType('resource').filter(resource => resource.name === src);
				this.set('esmDemoLoadTime', entries.length && entries.at(-1).transferSize ? Math.round(entries.at(-1).duration) : 0);

				let container = document.querySelector('.fireworks');
				container.style.zIndex = '1000';

				let fireworks = new Fireworks(container, {
					acceleration: 1.1,
					delay: { min: 10, max: 20 },
				});

				fireworks.start();

				setTimeout(() => {
					e.target.blur();
					fireworks.waitStop();
					container.style.zIndex = '-1';
					container.innerHTML = '';
				}, FIREWORKS_ANIMATION_DURATION);
			});
		},
	};
</script>
